import { Button } from '@mui/material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type React from 'react'
import { useState } from 'react'
import { DeleteTemplateModal } from './DeleteTemplateModal'
import { TemplateList } from './priv/TemplateList'
import type { CreateTemplateDialogProps, CreateTemplateFormData, PricePlanTemplate } from './priv/types'

interface TemplatesProps {
  onSaveTemplate: (templateFormData: CreateTemplateFormData) => Promise<void>
  onDeleteTemplate: (templateId: string) => void
  onNavigateToTemplate: (templateId: string) => void
  templates: PricePlanTemplate[]
  isLoading: boolean
  CreateTemplateDialog: React.ComponentType<CreateTemplateDialogProps>
}

export const Templates = ({
  onSaveTemplate,
  onDeleteTemplate,
  onNavigateToTemplate,
  templates,
  isLoading,
  CreateTemplateDialog,
}: TemplatesProps) => {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)
  const [deleteTemplateId, setDeleteTemplateId] = useState('')

  const handleDeleteTemplate = (templateId: string) => {
    setDeleteTemplateId(templateId)
  }

  return (
    <Stack width="100%" spacing="32px" sx={{ pt: '32px' }}>
      <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center" sx={{ pb: '24px' }}>
        <Typography variant="h4">Subscription Plan Templates</Typography>
        <Button variant="contained" color="primary" onClick={() => setIsCreateDialogOpen(true)}>
          Add template
        </Button>
      </Stack>

      <TemplateList
        templates={templates}
        isLoading={isLoading}
        onNavigateToTemplate={onNavigateToTemplate}
        onDeleteTemplate={handleDeleteTemplate}
      />

      <CreateTemplateDialog isOpen={isCreateDialogOpen} onSave={onSaveTemplate} onClose={() => setIsCreateDialogOpen(false)} />

      <DeleteTemplateModal
        templateId={deleteTemplateId}
        onCancel={() => setDeleteTemplateId('')}
        onDeleteTemplate={() => {
          onDeleteTemplate(deleteTemplateId)
          setDeleteTemplateId('')
        }}
      />
    </Stack>
  )
}
